module.exports = __webpack_public_path__ + "static/art-6-0582ba19e43e52820bb84bf61fcc197f.jpg";